import { render, staticRenderFns } from "./FilterSummaryOptionRiver.vue?vue&type=template&id=22a01b8d&"
import script from "./FilterSummaryOptionRiver.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionRiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports